/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'people.menu.renotify.flag.description': 'Wysyłamy każdemu e-mail z przypomnieniem. Może to zająć minutę.',
  'people.menu.renotify.flag.description.confluence': 'Wyślij przypomnienie członkom zespołu',
  'people.menu.renotify.flag.title': 'Wysyłanie przypomnień',
  'people.menu.renotify.flag.title.confluence': 'Ponowne wysyłanie e-maila z zaproszeniem',
  'people.menu.renotify.menu.description':
    '{userCount, plural, one {{userCount,number} osoba nie zaakceptowała zaproszenia do {product}. Zobacz, kogo brakuje i wyślij tej osobie przypomnienie.} few {{userCount,number} osoby nie zaakceptowały zaproszenia do {product}. Zobacz, kogo brakuje i wyślij im przypomnienie.} many {{userCount,number} osób nie zaakceptowało zaproszenia do {product}. Zobacz, kogo brakuje i wyślij im przypomnienie.} other {{userCount,number} osoby nie zaakceptowało zaproszenia do {product}. Zobacz, kogo brakuje i wyślij im przypomnienie.}}',
  'people.menu.renotify.menu.description.confluence':
    'Niektóre osoby nie zaakceptowały zaproszenia do Confluence. Zobacz, kogo brakuje, i wyślij im przypomnienie.',
  'people.menu.renotify.menu.dismiss': 'Zamknij',
  'people.menu.renotify.menu.dismiss.confluence': 'Nie teraz',
  'people.menu.renotify.menu.remind': 'Przypomnij członkom zespołu',
  'people.menu.renotify.menu.remind.confluence': 'Wyślij przypomnienie członkom zespołu',
  'people.menu.renotify.menu.title': 'Czy wszyscy już tu są?',
  'people.menu.renotify.modal.copied': 'Skopiowano łącze',
  'people.menu.renotify.modal.copy': 'Kopiuj łącze z zaproszeniem',
  'people.menu.renotify.modal.description':
    'Możemy wysłać e-mail z przypomnieniem do członków, których tu brakuje, lub możesz samodzielnie udostępnić łącze do zaproszenia.',
  'people.menu.renotify.modal.description.confluence':
    'Wyślij ponownie e-mail z zaproszeniem lub skopiuj i udostępnij łącze z zaproszeniem.',
  'people.menu.renotify.modal.dismiss': 'Anuluj',
  'people.menu.renotify.modal.resend': 'Wyślij przypomnienie',
  'people.menu.renotify.modal.resend.confluence': 'Wyślij ponownie zaproszenie',
  'people.menu.renotify.modal.title': 'Przypomnij brakującym członkom',
  'people.menu.renotify.modal.title.confluence': 'Przypomnienie dla brakujących członków zespołu',
  'ptc.pm.collaborators.title': 'Twoi współpracownicy',
  'ptc.pm.error-heading': 'Coś poszło nie tak',
  'ptc.pm.error-image-alt-text': 'Zepsuty robot i grupa ludzi zajętych naprawianiem go.',
  'ptc.pm.error-text':
    'Monitorujemy te błędy, ale możesz się z nami kontaktować, jeśli odświeżenie nie rozwiąże problemu.',
  'ptc.pm.num-members':
    '{memberCount, plural, one {{memberCount,number} członek} few {{memberCount,number} członków} many {{memberCount,number} członków} other {{memberCount,number} członka}}',
  'ptc.pm.people': 'Osoby',
  'ptc.pm.teams': 'Zespoły',
  'ptc.pm.view-your-profile': 'Wyświetl własny profil',
  'ptc.pm.your-teams.title': 'Twoje zespoły',
};
